// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__27ijh","inputWrap":"CustomTip_inputWrap__3WS61"};